module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc13-d1991c566f70ac3560c1cc341425a096.jpg";